(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@jmodule/client"));
	else if(typeof define === 'function' && define.amd)
		define(["@jmodule/client"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@jmodule/client")) : factory(root["@jmodule/client"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__853__) {
return 